import React, { Fragment, useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import Filter from "./Filter";
import alt from "./default.png";
import Search from "./Search";
import favicon from "../../img/tuTrend.png";
import "../../styles/fonts.css";
import "../../styles/index.css";
const Header = (props) => {
  const authContext = useContext(AuthContext);
  const { currentUser } = authContext;
  const [active, setActive] = useState("home");
  useEffect(() => {
    if (props.location.pathname === "/") {
      setActive("home");
    } else if (
      props.location.pathname === "/academics/videos" ||
      props.location.pathname === "/academics/notes" ||
      props.location.pathname === "/academics/profs"
    ) {
      setActive("academic");
    } else if (
      props.location.pathname === "/extracurriculars/videos" ||
      props.location.pathname === "/extracurriculars/notes"
    ) {
      setActive("extracurricular");
    } else if (props.location.pathname === "/youtube/videos") {
      setActive("youtube");
    } else {
      setActive("null");
    }
  }, [props.location]);

  return (
    <Fragment>
      <nav className='navbar navbar-dark bg-dark m-0 px-0 pb-0 px-md-2 pb-md-2'>
        <div className='col-xl-2 col-lg-2 col-md-4 col-11'>
          <Link
            to='/'
            className='navbar-brand text-light nolinklook '
            style={{ fontSize: "3em" }}
          >
            <img
              src={favicon}
              width='70'
              height='70'
              className='d-inline-block align-top'
              alt=''
              loading='lazy'
            />
            <span className='mainfont size11 mx-1'>tuTrend</span>
          </Link>
        </div>

        <Search history={props.history} />
        <div className='col-xl-5 col-lg-5 d-flex justify-content-between '>
          <button
            type='button'
            className='btn btn-light'
            data-toggle='modal'
            data-target='#filterModal'
          >
            <i className='fas fa-filter'></i>
            <span className='d-none d-md-inline d-lg-inine slantfont d-xl-inline'>
              Filter
            </span>
          </button>
          {currentUser ? (
            <>
              <Link to='/uplode'>
                <button type='button' className='btn btn-light'>
                  <i className='fas fa-upload'></i>
                  <span className='d-none slantfont d-md-inline d-lg-inine d-xl-inline'>
                    Upload
                  </span>
                </button>
              </Link>

              <Link
                className='nolinklook'
                to={`/viewaccount/${currentUser.uid}`}
                style={{ height: "100%" }}
              >
                <img
                  src={currentUser.photoURL || alt}
                  alt={currentUser.displayName}
                  loading='lazy'
                  width='40'
                  height='40'
                  className='rounded-circle border border-white'
                />
                <span className='text-light size09 titlefont nolinklook'>
                  {currentUser.displayName}
                </span>
              </Link>
            </>
          ) : (
            <>
              <Link to='/login'>
                <button type='button' className='btn btn-light'>
                  <i className='fas fa-sign-in-alt'></i>
                  <span className='size11 slantfont d-none d-md-inline d-lg-inine d-xl-inline'>
                    Login
                  </span>
                </button>
              </Link>
              <Link to='/register'>
                <button type='button' className='btn btn-light'>
                  <i className='fas fa-user-plus'></i>
                  <span className='size11 slantfont d-none d-md-inline d-lg-inine d-xl-inline'>
                    SignUp
                  </span>
                </button>
              </Link>
            </>
          )}
        </div>
      </nav>
      <nav className='navbar navbar-expand-lg bg-dark nav navbar-dark'>
        <button
          className='navbar-toggler'
          type='button'
          data-toggle='collapse'
          data-target='#navbarSupportedContent'
          aria-controls='navbarSupportedContent'
          aria-expanded='false'
          aria-label='Toggle navigation'
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <div className='collapse navbar-collapse' id='navbarSupportedContent'>
          <ul className='navbar-nav mr-auto nav nav-tabs nav navbar-dark'>
            <li className='nav-item text-center'>
              <Link
                to='/'
                className={`nav-link upperfont size09 ${
                  active === "home" ? "active text-dark" : "text-light"
                }`}
              >
                {" "}
                Home
              </Link>
            </li>
            <li className='nav-item dropdown text-center'>
              <a
                className={`nav-link dropdown-toggle upperfont size09 ${
                  active === "academic" ? "active text-dark" : "text-light"
                }`}
                href='/'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                Academic
              </a>
              <div
                className='dropdown-menu text-center'
                aria-labelledby='navbarDropdown'
              >
                <Link
                  to='/academics/videos'
                  className='text-dark upperfont size11 dropdown-item border-bottom border-dark'
                >
                  Videos
                </Link>
                <div className='divider'></div>
                <Link
                  to='/academics/notes'
                  className='dropdown-item  upperfont size11 text-dark border-bottom border-dark'
                >
                  Notes
                </Link>
                <div className='divider'></div>
                <Link
                  to='/academics/profs'
                  className='dropdown-item  upperfont size11 text-dark'
                >
                  Profs
                </Link>
              </div>
            </li>
            <li className='nav-item dropdown text-center'>
              <a
                className={`nav-link dropdown-toggle upperfont size09 ${
                  active === "extracurricular"
                    ? "active text-dark"
                    : "text-light"
                }`}
                href='/'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                Extracurricular
              </a>
              <div
                className='dropdown-menu text-center'
                aria-labelledby='navbarDropdown'
              >
                <Link
                  to='/extracurriculars/videos'
                  className='dropdown-item text-dark upperfont size11 border-bottom border-dark'
                >
                  Videos
                </Link>
                <Link
                  to='/extracurriculars/notes'
                  className='dropdown-item upperfont size11 text-dark'
                >
                  {" "}
                  Notes
                </Link>
              </div>
            </li>
            <li className='nav-item text-center'>
              <Link
                to='/youtube/videos'
                className={`nav-link upperfont size09 ${
                  active === "youtube" ? "active text-dark" : "text-light"
                }`}
              >
                {" "}
                Youtube
              </Link>
            </li>
          </ul>
        </div>

        <a
          className='nav-link p-1 text-light mx-2'
          target='_blank'
          href='https://www.facebook.com/tuTrend.web'
        >
          <i className='fab fa-facebook  size11'></i>
        </a>
        <a
          className='nav-link p-1 text-light mx-2'
          target='_blank'
          href='https://www.instagram.com/tutrend.in/?hl=en'
        >
          <i className='fab fa-instagram-square size11'></i>
        </a>
        <a
          className='nav-link p-1 text-light mx-2'
          href='https://www.linkedin.com/company/tutrend-in'
          target='_blank'
        >
          <i className='fab fa-linkedin-in  size11'></i>
        </a>
      </nav>

      <div
        className='modal fade'
        id='filterModal'
        tabIndex='-1'
        role='dialog'
        aria-labelledby='filterModalLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5
                className='modal-title text-center size09 fontcool'
                id='filterModalLabel'
              >
                Filter
              </h5>
              <button
                type='button'
                className='btn btn-outline-dark'
                data-dismiss='modal'
                aria-label='Close'
              >
                <i className='fas fa-times'></i>
              </button>
            </div>
            <div className='modal-body'>
              <Filter history={props.history} />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
